import React from 'react';
import NumberField from '../../../features/diagnostic/components/NumberField';
import { formatMoney, formatMoneyShort, formatSignedPercent } from '../../../features/diagnostic/format';

const QUICK_TARGETS = [
  { id: 'plus20', label: '+20%', multiplier: 1.2 },
  { id: 'plus50', label: '+50%', multiplier: 1.5 },
  { id: 'double', label: 'В 2 раза', multiplier: 2 },
];

const MONTH_OPTIONS = [3, 6, 12];

const StepGoal = ({ state, result, setField, showValidation = false }) => {
  const currentRevenue = result && result.valid ? result.state.revenue : 0;
  const target = Number(state.targetRevenue) || 0;
  const growthPercent = currentRevenue > 0 && target > 0 ? (target / currentRevenue - 1) * 100 : null;
  const targetInvalid = showValidation && !(target > 0);
  const exampleTarget = currentRevenue > 0 ? Math.round(currentRevenue * 1.5) : 4500000;

  return (
    <div className={`dg-step${targetInvalid ? ' is-needs-goal' : ''}`}>
      <h2 className="dg-step-title">Какую выручку хотите?</h2>
      <p className="dg-step-lead">
        Сейчас у вас {formatMoney(currentRevenue)} в месяц. Назовите цифру, к которой идёте —
        покажем, реально ли до неё дойти.
      </p>

      <div className={`dg-quick-targets${targetInvalid ? ' is-invalid' : ''}`}>
        {QUICK_TARGETS.map((quick) => {
          const value = Math.round(currentRevenue * quick.multiplier);
          const isActive = target === value;

          return (
            <button
              key={quick.id}
              type="button"
              className={`dg-quick-btn${isActive ? ' is-selected' : ''}`}
              onClick={() => setField('targetRevenue', value)}
            >
              <span className="dg-quick-label">{quick.label}</span>
              <span className="dg-quick-value">{formatMoneyShort(value)}</span>
            </button>
          );
        })}
      </div>

      <div className="dg-fields dg-fields--narrow">
        <NumberField
          label="Или своя цифра — выручка в месяц"
          suffix="₸"
          value={state.targetRevenue}
          onChange={(value) => setField('targetRevenue', value)}
          placeholder={`например ${exampleTarget}`}
          min={0}
          invalid={targetInvalid}
          errorMessage="Выберите цель выше или укажите свою цифру"
        />
      </div>

      {growthPercent !== null && growthPercent > 0 ? (
        <p className="dg-goal-note">
          Это рост на <strong>{formatSignedPercent(growthPercent)}</strong> к тому, что есть сейчас.
        </p>
      ) : null}

      <div className="dg-months">
        <span className="dg-months-label">За какой срок хотите дойти</span>
        <div className="dg-months-options">
          {MONTH_OPTIONS.map((months) => (
            <button
              key={months}
              type="button"
              className={`dg-month-btn${state.targetMonths === months ? ' is-selected' : ''}`}
              onClick={() => setField('targetMonths', months)}
            >
              {months} мес
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StepGoal;
